<template>
  <div class="flex flex-col">
    <div class="flex h-5 w-full flex-row items-center gap-0.5">
      <template v-for="(step, index) in timelineSteps" :key="step.id">
        <div
          v-if="index > 0"
          class="h-0.5 w-1 rounded-full"
          :class="lineClass(index <= activeTimelineIndex)"
        ></div>
        <BaseShapeMask
          v-if="step.state === 'current'"
          shape="flower"
          animation="spin"
          class="text-primary -m-0.5 shrink-0"
        >
          <div class="bg-primary h-5 w-5"></div>
        </BaseShapeMask>
        <div
          v-else-if="step.state === 'done'"
          class="border-primary bg-primary flex h-4 w-4 shrink-0 items-center justify-center rounded-full border"
        >
          <BaseIcon size="12" class="text-on-primary">check</BaseIcon>
        </div>
        <div
          v-else
          class="border-outline-variant flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2"
        ></div>
      </template>
    </div>
    <span class="text-label-medium text-primary mt-0.5">
      {{ timelineSteps[activeTimelineIndex]?.title }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
  import type { Dialog } from '@/core/models/dialog/dialog'
  import { useCoacheeDialogTimeline } from '@/modules/coachees/composables/use-coachee-dialog-timeline'

  interface Props {
    dialog: Omit<Dialog, 'coachee' | 'coach'>
  }

  const props = defineProps<Props>()

  const { timelineSteps, activeTimelineIndex, lineClass } = useCoacheeDialogTimeline(
    () => props.dialog,
  )
</script>
